import { fetchAuthenticatedImage } from '../api/services/authService';

export function isRemoteHttpUrl(url) {
  return typeof url === 'string' && /^https?:\/\//i.test(url.trim());
}

/**
 * Open an image that requires Authorization: Bearer. Plain window.open() fails on protected /api/files/... URLs.
 */
export async function openAuthenticatedImageInNewTab(url) {
  if (!url) return;
  const trimmed = url.trim();
  if (!isRemoteHttpUrl(trimmed)) {
    window.open(trimmed, '_blank', 'noopener,noreferrer');
    return;
  }

  const newWindow = window.open('', '_blank');
  if (newWindow) {
    try {
      newWindow.document.title = 'Image preview';
      newWindow.document.body.style.fontFamily = 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif';
      newWindow.document.body.style.padding = '16px';
      newWindow.document.body.textContent = 'Loading image…';
    } catch {
      /* ignore */
    }
  }

  try {
    const blobUrl = await fetchAuthenticatedImage(trimmed);
    if (!blobUrl) {
      if (newWindow) newWindow.close();
      throw new Error('Could not load image. Sign in again if your session expired.');
    }
    if (newWindow) {
      try {
        newWindow.opener = null;
      } catch {
        /* ignore */
      }
      newWindow.location.href = blobUrl;
    } else {
      window.open(blobUrl, '_blank', 'noopener,noreferrer');
    }
  } catch (err) {
    if (newWindow) newWindow.close();
    throw err;
  }
}
